import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function Button({
  children,
  fullWidth = false,
  onClick,
  href,
  className = ''
}: ButtonProps) {
  const handleClick = () => {
    if (href) {
      // Fire Meta Pixel AddToCart event before redirecting
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          content_name: 'Legado Digital Seguro',
          content_ids: ['legado-digital-seguro'],
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (onClick) {
      onClick();
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-gold hover:bg-gold-dark text-navy-dark font-semibold 
        py-5 px-10 rounded-xl shadow-lg transition-colors duration-300
        text-xl md:text-2xl flex items-center justify-center text-center cursor-pointer
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-30">
      {children}
    </motion.button>;
}